import $ from 'jquery';
import Swiper from 'swiper';
import {Navigation} from 'swiper/modules';
import {viewWidth} from "../Libraries/Utils";

const SLIDE_SPEED = 500;


$('.hepta-slider').each((i, elem) => {
    const $root = $(elem);

    const next = $root.find('.hepta-slider__nav .swiper-arrow--next')[0];
    const prev = $root.find('.hepta-slider__nav .swiper-arrow--prev')[0];
    const $slider = $root.find('.hepta-slider__slider');
    const $heptagons = $root.find('.hepta-slider__heptagon');

    const swapClass = ($el, oldSuffix, newSuffix) => {
        $el.removeClass(`hepta-slider__heptagon--${oldSuffix}`)
            .addClass(`hepta-slider__heptagon--${newSuffix}`)
    };
    const getHeptagons = () => {
        return [
            $heptagons.filter('.hepta-slider__heptagon--lo'),
            $heptagons.filter('.hepta-slider__heptagon--1'),
            $heptagons.filter('.hepta-slider__heptagon--2'),
            $heptagons.filter('.hepta-slider__heptagon--3'),
            $heptagons.filter('.hepta-slider__heptagon--ro'),
        ];
    };

    const swiper = new Swiper($slider[0], {
        modules: [Navigation],
        loop: false,
        slidesPerView: 1,
        spaceBetween: 130,
        allowTouchMove: false,
        autoHeight: true,
        speed: SLIDE_SPEED,
        navigation: {
            nextEl: next,
            prevEl: prev,
        },
        breakpoints: {
            992: {
                slidesPerView: 2,
            },
            1560: {
                slidesPerView: 3,
            }
        },

        on: {
            slidePrevTransitionStart: () => {
                const [$lo, $h1, $h2, $h3, $ro] = getHeptagons();
                // elements move to the right

                if (viewWidth() >= 1560) {
                    swapClass($lo, 'lo', '1');
                    swapClass($h1, '1', '2');
                    swapClass($h2, '2', '3');
                    swapClass($h3, '3', 'ro');
                    swapClass($ro, 'ro', 'lo');
                } else if (viewWidth() >= 992) {
                    swapClass($lo, 'lo', '1');
                    swapClass($h1, '1', '2');
                    swapClass($h2, '2', 'ro');
                    swapClass($ro, 'ro', 'lo');
                } else {
                    swapClass($lo, 'lo', '1');
                    swapClass($h1, '1', 'ro');
                    swapClass($ro, 'ro', 'lo');
                }
            },
            slideNextTransitionStart: () => {
                const [$lo, $h1, $h2, $h3, $ro] = getHeptagons();
                // elements move to the left

                if (viewWidth() >= 1560) {
                    swapClass($lo, 'lo', 'ro');
                    swapClass($h1, '1', 'lo');
                    swapClass($h2, '2', '1');
                    swapClass($h3, '3', '2');
                    swapClass($ro, 'ro', '3');
                } else if (viewWidth() >= 992) {
                    swapClass($lo, 'lo', 'ro');
                    swapClass($h1, '1', 'lo');
                    swapClass($h2, '2', '1');
                    swapClass($ro, 'ro', '2');
                } else {
                    swapClass($lo, 'lo', 'ro');
                    swapClass($h1, '1', 'lo');
                    swapClass($ro, 'ro', '1');
                }
            },
        }
    });
});
